import { useEffect } from 'react';

import { usePDFPreviewStore } from '../store/pdf-preview.store';
import type { TabRegistration } from '../types';

export const useRegisterTab = (registration: TabRegistration) => {
  const registerTab = usePDFPreviewStore((state) => state.registerTab);

  useEffect(() => {
    registerTab(registration);
  }, [registerTab, registration]);
};
